import { Business } from "@material-ui/icons";

export const Role = {
  All: "All",
  AdminIT: "AdminIT",
  AdminComercial: "AdminComercial",
  InternalSeller: "InternalSeller",
  ExternalSeller: "ExternalSeller",
  UserIntegration: "UserIntegration",
};

export const PaymentMethodTypes = {
  CreditCard: {
    Id: 1,
    Text: "Crédito",
  },
  DebitCard: {
    Id: 2,
    Text: "Débito",
  },
  CBU: {
    Id: 3,
    Text: "CBU",
  },
  Cash: {
    Id: 4,
    Text: "Efectivo",
  },
  BilledCash: {
    Id: 5,
    Text: "Efectivo Facturado",
  },
};

export const ChannelNumber = {
  DigitalHomeBanking: 1,
  BrancheOffice: 2,
  CallCenterBanking: 3,
  CallCenterSOS: 4,
};

export const DocumentTypes = {
  CUIT: 80,
  DNI: 96,
};

export const ReasonCancel = {
  CancelByWithdrawal: 1,
  CancelDueToDuplicity: 2,
  CancelForUnitSale: 3,
  CancelDueToLackOfPaymentCollection: 4,
  CancelsDueToHighSinisterFrequency: 5,
  CancelForEconomicProblems: 6,
  CancelDueToUnawarenessOfPurchase: 7,
  CancelForDisagreementWithTheService: 8,
  CancelDueToCancellationOfAllBankProducts: 9,
};

export const AgreementStatus = {
  Pending: {
    Id: 1,
    Text: "Pendiente",
  },
  Confirmed: {
    Id: 2,
    Text: "Confirmado",
  },
  Canceled: {
    Id: 3,
    Text: "Cancelado",
  },
  Expired: {
    Id: 4,
    Text: "Vencido",
  },
  NotRenewed: {
    Id: 5,
    Text: "No Renovado",
  },
};

export const UserCreate = {
  New: 1,
  Personal: 2,
};

export const RenewalStatus = {
  Enabled: 1,
  Disabled: 0,
};

export const IndicatorsType = {
  Confirmed: 1,
  Pending: 2,
  Expired: 3,
  Canceled: 4,
  NotRenewed: 5,
  Renewed: 6,
  PendingRenewal: 7,
};

export const IndicatorDetail = {
  Today: 1,
  Month: 2,
  Stock: 3,
};

export const PersonalType = {
  PersonalSOS: 1,
  Company: 2,
  PersonalExternal: 10,
};

export const PaymentsMethodAssign = {
  NotAssigned: 0,
  Assigned: 1,
};

export const AppNumber = {
  Retail: 150,
};

export const SalesChannelAssign = {
  NotAssigned: 0,
  Assigned: 1,
  All: 2,
};

export const StatusEnum = {
  Inactive: {
    Id: 0,
    Text: "Productos Inactivos",
  },
  Active: {
    Id: 1,
    Text: "Productos Activos",
  },
};

export const SaleStatusEnum = Object.freeze({
  Generated: { Id: 1, Description: "Pendiente" },
  WithContract: { Id: 2, Description: "Con contrato" },
  CompleteCustomerData: { Id: 3, Description: "Datos de cliente completos" },
  RejectedPayment: { Id: 4, Description: "Pago Rechazado" },
  Confirmed: { Id: 5, Description: "Confirmada" },
  Overdue: { Id: 6, Description: "Vencida" },
});

export const ProductTypesEnum = Object.freeze({
  Vehicular: { Id: 1, Description: "VEHICULAR" },
});

export const productTypeList = [
  {
    key: ProductTypesEnum.Vehicular.Id,
    value: ProductTypesEnum.Vehicular.Id,
    text: ProductTypesEnum.Vehicular.Description,
  },
];

export const VehicleTypeEnum = Object.freeze({
  Car: { Id: 1, Description: "AUTOMOVIL" },
  AllTerrain: { Id: 2, Description: "TODO TERRENO" },
  Truck: { Id: 3, Description: "CAMIÓN" },
  PickUp: { Id: 4, Description: "PICK UP" },
  Bus: { Id: 5, Description: "BUS" },
  Utilitarian: { Id: 6, Description: "UTILITARIO" },
  Motorcycle: { Id: 7, Description: "MOTOCICLETA" },
  Minivan: { Id: 8, Description: "MONOVOLUMEN" },
  CompactSUV: { Id: 9, Description: "SUV COMPACTO" },
  Bicycle: { Id: 10, Description: "BICICLETA" },
  Van: { Id: 11, Description: "FURGON" },
});

export const vehicleTypeList = [
  {
    key: VehicleTypeEnum.Car.Id,
    value: VehicleTypeEnum.Car.Id,
    text: VehicleTypeEnum.Car.Description,
  },
  {
    key: VehicleTypeEnum.AllTerrain.Id,
    value: VehicleTypeEnum.AllTerrain.Id,
    text: VehicleTypeEnum.AllTerrain.Description,
  },
  {
    key: VehicleTypeEnum.Truck.Id,
    value: VehicleTypeEnum.Truck.Id,
    text: VehicleTypeEnum.Truck.Description,
  },
  {
    key: VehicleTypeEnum.PickUp.Id,
    value: VehicleTypeEnum.PickUp.Id,
    text: VehicleTypeEnum.PickUp.Description,
  },
  {
    key: VehicleTypeEnum.Bus.Id,
    value: VehicleTypeEnum.Bus.Id,
    text: VehicleTypeEnum.Bus.Description,
  },
  {
    key: VehicleTypeEnum.Utilitarian.Id,
    value: VehicleTypeEnum.Utilitarian.Id,
    text: VehicleTypeEnum.Utilitarian.Description,
  },
  {
    key: VehicleTypeEnum.Motorcycle.Id,
    value: VehicleTypeEnum.Motorcycle.Id,
    text: VehicleTypeEnum.Motorcycle.Description,
  },
  {
    key: VehicleTypeEnum.Minivan.Id,
    value: VehicleTypeEnum.Minivan.Id,
    text: VehicleTypeEnum.Minivan.Description,
  },
  {
    key: VehicleTypeEnum.CompactSUV.Id,
    value: VehicleTypeEnum.CompactSUV.Id,
    text: VehicleTypeEnum.CompactSUV.Description,
  },
  {
    key: VehicleTypeEnum.Bicycle.Id,
    value: VehicleTypeEnum.Bicycle.Id,
    text: VehicleTypeEnum.Bicycle.Description,
  },
  {
    key: VehicleTypeEnum.Van.Id,
    value: VehicleTypeEnum.Van.Id,
    text: VehicleTypeEnum.Van.Description,
  },
];

export const ResultEnum = {
  Fail: 0,
  Success: 1,
};

export const IdentificationTypeEnum = Object.freeze({
  CIPF: {
    Id: 0,
    Description: "CEDULA IDENT. POLICIA FEDERAL",
  },
  CUIT: {
    Id: 80,
    Description: "CODIGO UNICO IDENT TRIBUTARIA",
  },
  DNRP: {
    Id: 85,
    Description: "DIR.NAC.REC.PREVISIONAL",
  },
  LE: {
    Id: 89,
    Description: "LIBRETA ENROLAMIENTO",
  },
  LC: {
    Id: 90,
    Description: "LIBRETA CIVICA",
  },
  PAS: {
    Id: 94,
    Description: "PASAPORTE",
  },
  DNI: {
    Id: 96,
    Description: "DOCUMENTO NACIONAL IDENTIDAD",
  },
  CUIL: {
    Id: 97,
    Description: "CODIGO UNICO IDENT.LABORAL",
  },
});

export const CustomerTypeEnum = {
  FinalCustomer: 0,
  Business: 1,
};
